const opinionList = [
  "finishDate",
  "contactPerson",
  "duration",
  "servicePackage.name",
  "pricePackage.name",
  "documentPageCount",
  "specialFee",
  "status",
  "workingTime",
  "dueDate",
  "sendDate",
  "supervisor",
  "servicePackagePrice",
  "pricePackagePrice",
  "express",
  "doneByCbEvaluation",
  "totalPrice",
  "surcharges",
  "followingGoae"
]

const opinionOverviewList = [
  "finishDate",
  "createdAt",
  "contactPerson",
  "duration",
  "expert",
  "express",
  "doneByCb",
  "servicePackage.name",
  "ignoreMissingDocuments",
  "preCaseReferenceNumber",
  "costBearer.name",
  "pricePackage.name",
  "supervisor",
  "documentPageCount",
  "icons",
  "status",
  "sendDate",
  "workingTime",
  "dueDate",
  "servicePackagePrice",
  "pricePackagePrice",
  "doneByCbEvaluation",
  "totalPrice",
  "surcharges",
  "followingGoae"
]

export default {
  shortOpinionsList: localStorage
    .getItem("filterHeaders.shortOpinionsList")
    ?.split(",") || [
    ...opinionList,
    "treatments",
    "testOrders",
    "conclusion.name",
    "policyHolder.birthDate",
    "policyHolder.gender"
  ],
  shortOpinionOverviewList: localStorage
    .getItem("filterHeaders.shortOpinionOverviewList")
    ?.split(",") || [
    ...opinionOverviewList,
    "goae",
    "treatments",
    "testOrders",
    "conclusion.name",
    "policyHolder.birthDate",
    "policyHolder.gender",
    "policyHolder.insuranceNumber"
  ],
  secondOpinionsList: localStorage
    .getItem("filterHeaders.secondOpinionsList")
    ?.split(",") || [...opinionList, "patient.birthDate", "patient.gender"],
  secondOpinionOverviewList: localStorage
    .getItem("filterHeaders.secondOpinionOverviewList")
    ?.split(",") || [
    ...opinionOverviewList,
    "patient.birthDate",
    "patient.gender",
    "patient.insuranceNumber"
  ],
  goaesList: localStorage.getItem("filterHeaders.goaesList")?.split(",") || [
    ...opinionList,
    "policyHolder.birthDate",
    "policyHolder.gender",
    "insuranceRate",
    "policyHolderPayed",
    "invoices.invoiceAmount",
    "invoices.reimbursementAmount",
    "invoices.reductionAmount",
    "option",
    "contradictionCounter"
  ],
  goaesOverviewList: localStorage
    .getItem("filterHeaders.goaesOverviewList")
    ?.split(",") || [
    ...opinionOverviewList,
    "shortOpinion",
    "proceed",
    "option",
    "contradictionCounter",
    "insuranceRate",
    "policyHolder.birthDate",
    "policyHolder.gender",
    "policyHolder.insuranceNumber",
    "policyHolderPayed",
    "invoices.invoiceAmount",
    "invoices.reimbursementAmount",
    "invoices.reductionAmount"
  ],
  evaluation: localStorage.getItem("filterHeaders.evaluation")?.split(",") || [
    "policyHolder.insuranceNumber",
    "policyHolder.gender",
    "policyHolder.birthDate",
    "supervisor",
    "createdAt",
    "dueDate",
    "finishDate",
    "contactPerson",
    "supervisor",
    "note",
    "express",
    "reclaim",
    "preCaseReferenceNumber",
    "goae",
    "shortOpinion",
    "sendDate",
    "cancellation",
    "specialFee",
    "checkDueDate",
    "openBy",
    "doneByCb",
    "workingTime",
    "servicePackagePrice",
    "pricePackagePrice"
  ],
  evaluation_summary: localStorage
    .getItem("filterHeaders.evaluation_summary")
    ?.split(",") || ["conclusions", "directCount", "contradictionsCount"],
  evaluation_summary_subject: localStorage
    .getItem("filterHeaders.evaluation_summary")
    ?.split(",") || ["conclusions"]
}
